import { createSelector } from 'reselect';

import { NONE_TEMPLATE_ID } from '../../../constants';
import { isNotEmptyString } from '../../../util/object';

import { inEpisodeFlow } from '../../routes/state-management/selectors';
import { getPlayableFrameRanges } from './playableFrameSelectors';
import {
  shiftFrameRangesBeforeFrameToTail,
  truncateFrameRanges,
} from '../../../util/frameRange';
import { createKeyedStateSelector } from '../../shared/utils/selectorUtils';
import { getCreativeTemplateId } from '../../shared/playback/state-management/selectors';
import { getCurrentFrame } from '../manager/PlaybackManager';

export const isAudible = (state) => state.playback.audible;
export const getZoomScale = (state) => state.playback.zoomLevel;
export const isBufferingEnabled = (state) => inEpisodeFlow(state);

export const speed = (state) => state.playback.speed;

export const shouldLoopPlayback = (state) => !inEpisodeFlow(state);

export const isCreativeUsingTemplate = createSelector(
  [getCreativeTemplateId],
  (creativeTemplateId) =>
    isNotEmptyString(creativeTemplateId) &&
    creativeTemplateId !== NONE_TEMPLATE_ID,
);

export const paused = (state) => state.playback.paused;
export const playing = (state) => !state.playback.paused;

/**
 * Returns a list of frame ranges that are N frames away from the current frame.
 * If those frames are beyond the end of the playable frame ranges, frames from
 * the beginning of the playable frame ranges will be included at the end.
 * @returns {FrameRange[]}
 */
export const getFrameRangesToBuffer = createKeyedStateSelector(
  [
    getCurrentFrame,
    getPlayableFrameRanges,
    (state, numFramesToBufferFromCurrent) => numFramesToBufferFromCurrent,
  ],
  (currentFrame, playableFrameRanges, numFramesToBufferFromCurrent) => {
    const nextFrameRanges = shiftFrameRangesBeforeFrameToTail(
      playableFrameRanges,
      currentFrame,
    );
    return truncateFrameRanges(nextFrameRanges, numFramesToBufferFromCurrent);
  },
);
